import { useState, useEffect } from "react";
import * as api from "../api/api";
import DropdownSearch from "../Components/DropdownSearch";
import DropdownSearchSingle from "../Components/DropdownSearchSingle";
import Loading from "../Components/Loading";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import LastPageIcon from "@mui/icons-material/LastPage";
import { Button } from "@mui/material";
import Select from "react-select";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import checkAuthorization from "../config/checkAuth";
import dayjs from "dayjs";
import strings from "../Components/Localization/strings";
import { useLanguage } from "../Components/Localization/LanguageContext";
import { UserCacheProvider } from "../Components/UserCacheProvider";
import { useUserCache } from "../Components/UserCacheProvider";
import { useRef } from "react";

export default function AdminLiveView() {
  const [isLoading, setLoading] = useState(false);
  const [historyForms, setHistoryForms] = useState([]);
  const { language } = useLanguage();
  const pageTitle = "AdminLiveView";
  const { getUser, setUser } = useUserCache();

  const activityTypes = strings[pageTitle][language].activityTypes;

  const [currentPage, setCurrentPage] = useState(1);
  const [numberOfPages, setNumberOfPages] = useState(1);
  const [numberOfItems, setNumberOfItems] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const pageSizeOptions = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  const navigate = useNavigate();

  function getFormattedDate(date) {
    const today = date;

    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    const day = today.getDate().toString().padStart(2, "0");
    const hours = "00";
    const minutes = "00";
    const seconds = "00";

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  function getFormattedDateWithHours(date) {
    const today = date;

    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    const day = today.getDate().toString().padStart(2, "0");
    const hours = today.getHours().toString().padStart(2, "0");
    const minutes = today.getMinutes().toString().padStart(2, "0");

    return `${year}-${month}-${day}_${hours}-${minutes}`;
  }

  const startDateString = getFormattedDate(new Date());
  const endDateString = getFormattedDate(
    new Date(Date.now() + 24 * 60 * 60 * 1000),
  );

  function timestampToHHMMSS(timestamp) {
    const dateObject = new Date(timestamp);

    const hours = dateObject.getHours().toString().padStart(2, "0");
    const minutes = dateObject.getMinutes().toString().padStart(2, "0");
    const seconds = dateObject.getSeconds().toString().padStart(2, "0");

    const formattedTime = `${hours}:${minutes}:${seconds}`;

    return formattedTime;
  }

  const [filter, setFilter] = useState({
    startDate: startDateString,
    endDate: endDateString,
    page: currentPage,
    size: pageSize,
    formIds: [],
    serviceIds: [],
    teamIds: [],
    userIds: [],
    processTypeIds: [],
    isBillable: null,
    isFinalized: false,
  });
  const [services, setServices] = useState([]);
  const [forms, setForms] = useState([]);
  const [users, setUsers] = useState([]);
  const [teams, setTeams] = useState([]);
  const [triggerTimeout, setTriggerTimeout] = useState(false);
  const billableTypes = strings[pageTitle][language].billableTypes;

  const initialiseFilterItems = () => {
    api.getAllServices().then((response) => {
      setServices(response.data.object);
    });
    api.getAllForms().then((response) => {
      setForms(response.data.object);
    });
    api.getAllUsers().then((response) => {
      setUsers(response.data.object);
      response.data.object.forEach((user) => {
        setUser(user.userId, user);
      });
    });
    api.getAllTeams().then((response) => {
      setTeams(response.data.object);
    });
  };

  function secondsToHMS(seconds) {
    var hours = Math.floor(seconds / 3600);
    var minutes = Math.floor((seconds % 3600) / 60);
    var remainingSeconds = Math.floor(seconds % 60);

    // Add leading zeros if needed
    hours = hours < 10 ? "0" + hours : hours;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    remainingSeconds =
      remainingSeconds < 10 ? "0" + remainingSeconds : remainingSeconds;

    return hours + ":" + minutes + ":" + remainingSeconds;
  }

  const compareTimestampToCurrentTime = (timestamp) => {
    // Parse the provided timestamp
    const providedTime = dayjs(timestamp);

    // Get the current time
    const currentTime = dayjs();

    // Calculate the duration difference
    const durationDifference = currentTime.diff(providedTime, "second");

    return durationDifference;
  };

  const filterRef = useRef(filter);

  useEffect(() => {
    filterRef.current = filter;
  }, [filter]);

  const handleFetchFilteredProcesses = async (values, page = 1) => {
    let searchParts = values;
    try {
      searchParts = {
        [values?.split(":")[0]]: values.split(":")[1].split(","),
      };
      if (searchParts.hasOwnProperty("processTypeIds")) {
        let idValues = [];
        searchParts.processTypeIds.forEach((value) => {
          function findIdByName(name) {
            const activity = activityTypes.find(
              (activity) => activity.name === name,
            );
            return activity ? activity.id : null;
          }
          idValues.push(findIdByName(value));
        });
        if (idValues[0] === null) {
          searchParts.processTypeIds = null;
        } else {
          searchParts.processTypeIds = idValues;
        }
      } else if (searchParts.hasOwnProperty("serviceIds")) {
        let idValues = [];
        console.log(searchParts.serviceIds);
        searchParts.serviceIds.forEach((value) => {
          function findIdByName(name) {
            const activity = services.find((service) => service.name === name);
            return activity ? activity.serviceId : null;
          }
          idValues.push(findIdByName(value));
        });
        if (idValues[0] === null) {
          searchParts.serviceIds = null;
        } else {
          searchParts.serviceIds = idValues;
        }
      } else if (searchParts.hasOwnProperty("formIds")) {
        let idValues = [];
        searchParts?.formIds.forEach((value) => {
          function findIdByName(name) {
            const activity = forms.find((form) => form.name === name);
            return activity ? activity?.formId : null;
          }
          idValues.push(findIdByName(value));
        });
        if (idValues[0] === null) {
          searchParts.formIds = null;
        } else {
          searchParts.formIds = idValues;
        }
      } else if (searchParts.hasOwnProperty("userIds")) {
        let idValues = [];
        searchParts.userIds.forEach((value) => {
          function findIdByName(username) {
            const user = users.find((user) => user.username === username);
            return user ? user.userId : -1;
          }
          idValues.push(findIdByName(value));
        });

        if (idValues[0] === -1 && idValues.length === 1) {
          console.log("hena");
          searchParts.userIds = [];
        } else {
          searchParts.userIds = idValues;
        }
        console.log(searchParts);
      } else if (searchParts.hasOwnProperty("teamIds")) {
        let idValues = [];
        searchParts.teamIds.forEach((value) => {
          function findIdByName(name) {
            const activity = teams.find((team) => team.name === name);
            return activity ? activity.teamId : null;
          }
          idValues.push(findIdByName(value));
        });
        searchParts.teamIds = idValues;
      } else if (searchParts.hasOwnProperty("isBillable")) {
        if (searchParts["isBillable"] == "true") {
          searchParts["isBillable"] = true;
        } else if (searchParts["isBillable"] == "false") {
          searchParts["isBillable"] = false;
        } else {
          searchParts["isBillable"] = null;
        }
      } else if (searchParts.hasOwnProperty("isFinalized")) {
        if (searchParts["isFinalized"] == "true") {
          searchParts["isFinalized"] = true;
        } else if (searchParts["isFinalized"] == "false") {
          searchParts["isFinalized"] = false;
        } else {
          searchParts["isFinalized"] = null;
        }
      }
      console.log(searchParts);
    } catch (e) {
      console.log(e);
    }

    const updatedFilter = { ...filter, ...searchParts, page: page };
    setCurrentPage(page);
    setLoading(true);
    setFilter(updatedFilter);

    try {
      const response = await api.getAllFilteredReports(updatedFilter);

      setNumberOfPages(response.data.object.totalPages);
      const { history, current } = response.data.object;

      const getUserByIdPromises = current.map(async (process) => {
        process.user = await getUser(process.userId).then((user) => user);
        return process;
      });

      // after all promises are resolved, set the state

      const updatedProcesses = await Promise.all(getUserByIdPromises);
      console.log(updatedProcesses);

      updatedProcesses.forEach((process) => {
        let sumDurations = 0;
        if (process.allProcessTimes && process.allProcessTimes.length > 0) {
          process.allProcessTimes.forEach((time) => {
            sumDurations += time.duration;
          });
          let extraFromLastProcessTimeToNow = compareTimestampToCurrentTime(
            process.allProcessTimes[process.allProcessTimes.length - 1]
              .startTime,
          );
          process.duration = sumDurations + extraFromLastProcessTimeToNow;
        } else {
          process.duration = 0;
        }
      });

      setHistoryForms(updatedProcesses);

      if (
        response.data.object.currentPage === 1 &&
        response.data.object.size === 0
      ) {
        setCurrentPage(0);
      }
      setNumberOfItems(
        current.filter(
          (process) =>
            process.allProcessTimes && process.allProcessTimes.length > 0,
        ).length,
      );
      setLoading(false);
    } catch (error) {
      console.error("Error fetching filtered reports:", error);
      setLoading(false);
    }
  };

  // const renewProcesses = () => {
  //   if (currentPage === 1) {
  //     handleFetchFilteredProcesses(filterRef.current, currentPage);;
  //     // this flip flops between true and false to use as a trigger for the useeffect
  //     setTriggerTimeout(!triggerTimeout);
  //   }
  // };

  // useEffect(() => {
  //   const timeoutID = window.setTimeout(() => {
  //     renewProcesses();
  //   }, 20000);

  //   return () => window.clearTimeout(timeoutID);
  // }, [currentPage, triggerTimeout]);

  const renewProcesses = () => {
    if (currentPage === 1) {
      handleFetchFilteredProcesses(filterRef.current, currentPage);
      console.log("REF FILTER", filterRef.current);
      console.log("STATE FILTER", filter);
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      renewProcesses();
    }, 20000);

    return () => clearInterval(intervalId);
  }, [currentPage]);

  useEffect(() => {
    if (pageSize !== filter.size) {
      const updatedFilter = { ...filter, size: pageSize, page: 1 };
      setFilter(updatedFilter);
      setCurrentPage(1);

      // Use the updated filter directly for the API call
      setLoading(true);
      api.getAllFilteredReports(updatedFilter).then(async (response) => {
        setNumberOfPages(response.data.object.totalPages);

        const { history, current } = response.data.object;

        const getUserByIdPromises = current.map(async (process) => {
          process.user = await getUser(process.userId).then((user) => user);
          return process;
        });

        const updatedProcesses = await Promise.all(getUserByIdPromises);

        updatedProcesses.forEach((process) => {
          let sumDurations = 0;
          if (process.allProcessTimes && process.allProcessTimes.length > 0) {
            process.allProcessTimes.forEach((time) => {
              sumDurations += time.duration;
            });
            let extraFromLastProcessTimeToNow = compareTimestampToCurrentTime(
              process.allProcessTimes[process.allProcessTimes.length - 1]
                .startTime,
            );
            process.duration = sumDurations + extraFromLastProcessTimeToNow;
          } else {
            process.duration = 0;
          }
        });

        setHistoryForms(updatedProcesses);

        if (
          response.data.object.currentPage === 1 &&
          response.data.object.size === 0
        ) {
          setCurrentPage(0);
        }
        setNumberOfItems(
          current.filter((process) => process.allProcessTimes.length > 0)
            .length,
        );
        setLoading(false);
      });
    }
  }, [pageSize]);

  useEffect(() => {
    let intervalId;

    checkAuthorization("LIVE_VIEW").then((result) => {
      if (result) {
        handleFetchFilteredProcesses(filterRef.current, currentPage);
        initialiseFilterItems();
        /*intervalId = setInterval(() => {
          // Code to run every 10 seconds
          // USE ANOTHER FUNCTION OTHER THAN HANDLEFETCHFILTEREDPROCESSES, A GOOD FUNCTION WOULD BE ONE THAT
          // NOT JUST FETCHES THE PROCESSES, BUT RATHER ONE THAT APPENDS TO THEM
          // renewProcesses();
        }, 5000);*/
      } else {
        navigate("/unauthorized");
      }
    });
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="main-content-container" style={{ position: "relative" }}>
      <div className="main-content">
        <div>
          <div className="main-content__title d-flex align-items-center justify-content-between">
            <h6 className="">{strings[pageTitle][language].pageTitle} </h6>
            <div className="d-flex align-items-end gap-2 "></div>
          </div>
          <hr className="main-content-title__hr" />

          <div className="ms-2 mt-2 d-flex gap-1 max-width-800 mx-auto p-3  flex-wrap">
            <h6 className="grid-item-title" style={{ whiteSpace: "nowrap" }}>
              {strings[pageTitle][language].filterBy}{" "}
            </h6>
            <DropdownSearch
              items={activityTypes}
              label="Activity Type"
              triggerSearch={handleFetchFilteredProcesses}
              labelText={strings[pageTitle][language].filterItems[0]}
            ></DropdownSearch>
            <DropdownSearch
              items={services}
              label="Services"
              triggerSearch={handleFetchFilteredProcesses}
              labelText={strings[pageTitle][language].filterItems[1]}
            ></DropdownSearch>
            <DropdownSearch
              items={forms}
              label="Forms"
              triggerSearch={handleFetchFilteredProcesses}
              labelText={strings[pageTitle][language].filterItems[2]}
            ></DropdownSearch>
            <DropdownSearch
              items={users}
              label="Users"
              triggerSearch={handleFetchFilteredProcesses}
              labelText={strings[pageTitle][language].filterItems[3]}
            ></DropdownSearch>
            <DropdownSearch
              items={teams}
              label="Teams"
              triggerSearch={handleFetchFilteredProcesses}
              labelText={strings[pageTitle][language].filterItems[4]}
            ></DropdownSearch>
            <DropdownSearchSingle
              items={billableTypes}
              label="Billable"
              triggerSearch={handleFetchFilteredProcesses}
              labelText={strings[pageTitle][language].filterItems[5]}
            ></DropdownSearchSingle>
          </div>
          {isLoading ? (
            <Loading />
          ) : (
            <>
              <table
                style={{ boxSizing: "content-box", margin: "2em" }}
                className="activity-table"
              >
                <thead>
                  <tr>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[0]}
                    </th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[1]}
                    </th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[2]}
                    </th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[3]}
                    </th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[4]}
                    </th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[5]}
                    </th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[6]}
                    </th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[7]}
                    </th>

                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[8]}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {historyForms &&
                    historyForms.map((process, index) => (
                      <tr>
                        <td>{process.processType.name}</td>
                        <td>{process.service.name}</td>
                        <td>{process.form?.name}</td>
                        <td>
                          {teams.find((t) => t.teamId == process.teamId)
                            ?.name || process?.teamId}
                        </td>
                        <td>{process.user?.name}</td>
                        <td>{process.user?.userId}</td>
                        <td>{process.user?.username}</td>
                        <td>{process.isBillable ? "True" : "False"}</td>
                        <td>{secondsToHMS(process.duration)}</td>
                      </tr>
                    ))}
                </tbody>
              </table>

              <div
                style={{ borderBottom: "1px solid black", margin: "1em" }}
              ></div>
              <nav className="pagination-container">
                <div
                  style={{
                    minWidth: "100px",
                    marginRight: "1em",
                    position: "absolute",
                    right: "0",
                  }}
                >
                  <Select
                    options={pageSizeOptions}
                    value={pageSizeOptions.find(
                      (opt) => opt.value === pageSize,
                    )}
                    onChange={(selectedOption) =>
                      setPageSize(selectedOption.value)
                    }
                    isSearchable={false}
                  />
                </div>
                <ul className="pagination">
                  <li>
                    <Button
                      onClick={() => {
                        setFilter({ ...filter, page: 1 });
                        setCurrentPage(1);
                        handleFetchFilteredProcesses("", 1);
                      }}
                      disabled={currentPage == 1 || currentPage == 0}
                    >
                      <FirstPageIcon></FirstPageIcon>{" "}
                      {strings[pageTitle][language].first}
                    </Button>
                  </li>
                  <li>
                    <Button
                      onClick={() => {
                        setFilter({ ...filter, page: currentPage - 1 });

                        setCurrentPage(currentPage - 1);
                        handleFetchFilteredProcesses("", currentPage - 1);
                      }}
                      disabled={currentPage == 1 || currentPage == 0}
                    >
                      <ArrowBackIosIcon></ArrowBackIosIcon>{" "}
                      {strings[pageTitle][language].previous}
                    </Button>
                  </li>
                </ul>

                <p>
                  {strings[pageTitle][language].page} {currentPage}{" "}
                  {strings[pageTitle][language].of} {numberOfPages} (
                  {numberOfItems} {strings[pageTitle][language].items})
                </p>
                <ul className="pagination">
                  <li>
                    <Button
                      onClick={() => {
                        setFilter({ ...filter, page: currentPage + 1 });

                        setCurrentPage(currentPage + 1);
                        handleFetchFilteredProcesses("", currentPage + 1);
                      }}
                      disabled={currentPage === numberOfPages}
                    >
                      {strings[pageTitle][language].next}{" "}
                      <ArrowForwardIosIcon></ArrowForwardIosIcon>
                    </Button>
                  </li>
                  <li>
                    <Button
                      onClick={() => {
                        console.log(numberOfPages);

                        setCurrentPage(numberOfPages);
                        handleFetchFilteredProcesses("", numberOfPages);
                      }}
                      disabled={currentPage == numberOfPages}
                    >
                      {strings[pageTitle][language].last}
                      <LastPageIcon></LastPageIcon>
                    </Button>
                  </li>
                </ul>
              </nav>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
